export default __webpack_public_path__ + "static/media/react.b82b2c8d.jpeg";